import { render, staticRenderFns } from "./RegionalForm.vue?vue&type=template&id=27bdc197&scoped=true&"
import script from "./RegionalForm.vue?vue&type=script&lang=js&"
export * from "./RegionalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bdc197",
  null
  
)

export default component.exports